import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AppSection />
        <MediaSection />
        <IndexSection />
        <FaqSection />
        <TopicsSection />
        <ContactSection />
        <CardsSection />
        <AboutSection />
        <UpdatesSection />
        <CarouselSection />
        <FeaturesSection />
        <RankingSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}